export default __webpack_public_path__ + "static/media/pfp3.63c3a335.png";